import React, { useEffect, useState, useRef } from "react"
import { Container } from "reactstrap"
import { useSelector, useDispatch } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next"
import { withRouter, Link , useHistory} from "react-router-dom"
import { size } from "lodash"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import SimpleBar from "simplebar-react"
import {
  Card,
  CardBody,
  CardTitle,
  Media,
  CardText,
  CardHeader,
  Table,
  Row,
  Col,
  Badge,
  Spinner,
  Button,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
} from "reactstrap"
import * as moment from "moment"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getSalesEntryList } from "helpers/backend_helper"
import { getCustomerSalesSummary } from "helpers/backend_helper"
import { getAllCustomers as onGetAllCustomers } from "store/products/actions"

const CustomerListDetailed = (props) => {

  const dispatch = useDispatch()
  const history = useHistory()

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      setSelectedCustId(params.id)
      getAllDetails(params.id)
    } 
  }, [])

  function getAllDetails(custid){
    getCustomerSummary({
      customerid: custid
    })
    getCustmerSalesList({
      customerid: custid
    })
  }

  useEffect(() => {
    dispatch(onGetAllCustomers(true))
  }, [dispatch]);

  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
  }


  const [salesEntryList, setSalesEntryList] = useState([])
  const [showLoading, setShowLoading] = useState(false)
  const [searchInProgress, setSearchInProgress] = useState(false)
  const [selectedCustId, setSelectedCustId] = useState()
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [customerFilteredList, setCustomerFilteredList] = useState([])
  const [customerSalesSummary, setCustomerSalesSummary] = useState({})

  const { customerList } = useSelector(state => ({
    customerList: state.Products.customers,
  }))

  useEffect(() => {
    setCustomerFilteredList(customerList)
    scrollToBottom()
  }, [customerList])


  async function getCustomerSummary(searchCriteria){
    setShowLoading(true)
    getCustomerSalesSummary(searchCriteria).then(result => {
      setCustomerSalesSummary(result)
      setShowLoading(false)
    })
  }

  async function getCustmerSalesList(searchCritiria){
    setSearchInProgress(true)
    getSalesEntryList(searchCritiria).then(result => {
      setSalesEntryList(result)
      setSearchInProgress(false)
    })
  }

  function close(){
    history.push('/list-customer')
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const pageOptions = {
    sizePerPage: 15,
    totalSize: size(salesEntryList), 
    custom: true,
  }

  const SalesEntryListColumns = () => [
    {
      dataField: "invoiceno",
      text: "Inv #",
      sort: true
    },
    {
      dataField: "invoicedate",
      text: "Invoice Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
      filterValue: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "grandtotal",
      text: "Amount",
      sort: true,
      sortValue: (cell, row) => Number(cell),
      formatter: (cellContent, row) => (
        <div>
          {Number(cellContent).toLocaleString('en-IN',{minimumFractionDigits: 2})}
          {Number(row.currentwriteoff) > 0 ? <div className="text-muted font-size-12">Write-Off : {Number(row.currentwriteoff).toLocaleString('en-IN',{minimumFractionDigits: 2})}</div>: null}
        </div>
      ),
    },
    ,
    {
      dataField: "cashreceived",
      text: "Balance Amount",
      sort: true,
      sortValue: (cell, row) => (Number(row.grandtotal)-(Number(row.cashreceived) + Number(row.currentwriteoff))),
      formatter: (cellContent, row) => (
        (Number(row.grandtotal)-(Number(row.cashreceived) + Number(row.currentwriteoff))).toLocaleString('en-IN',{minimumFractionDigits: 2})
      ),
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => (
        <Badge className={cellContent== "PAID"? "font-size-12 bg-success badge-success":"font-size-12 bg-warning badge-warning"}>
          {cellContent}
        </Badge>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent, item) => (
        <>

        {<UncontrolledDropdown>
          <DropdownToggle
            href="#"
            className="card-drop"
            tag="i"
            onClick={(e) => {e.stopPropagation()}}
          >
            <i className="mdi mdi-dots-horizontal font-size-18 pointer-cursor" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
          
            <DropdownItem
              tag={Link} 
              to={"/view-sales-entries/"+item.id}
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="bx bx-detail font-size-16 text-info me-1" />{" "}
              View Details
            </DropdownItem>
            <DropdownItem
              tag={Link} 
              to={"/edit-salesentry/"+item.id}
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="mdi mdi-pencil font-size-16 text-success me-1" />{" "}
              Edit
            </DropdownItem>
            <DropdownItem
              tag={Link} 
              to={"/add-sales-payment/"+item.customerid}
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="bx bx-dollar font-size-16 text-primary me-1" />{" "}
              Add Payment
            </DropdownItem>
            {/*<DropdownItem
              href="#"
              onClick={(e) => {e.stopPropagation()}}
            >
              <i className="bx bx-reset font-size-16 text-danger me-1" />{" "}
              Add Sales Return
            </DropdownItem>*/}
          </DropdownMenu>
        </UncontrolledDropdown>
        }
        </>
      ),
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Manage" breadcrumbItem="Customer Transactions" breadcrumbLink="/list-customer"/>
          <Card>
            <CardBody className="no-x-padding">
              <Row className="">
                <Col lg="4">
                  <Row>
                    <Col className="text-center fw-medium font-size-15">
                      Customers
                    </Col>
                  </Row>
                  <div className="mt-2 mb-3 ms-2 pt-2">
                    <Select
                      onChange={(e) => {
                        setSelectedCustomer(e)
                        if(e?.value){
                          setSelectedCustId(e.value)
                          getAllDetails(e.value)
                          const fileredList = customerList.filter(each => each.value == e.value)
                          setCustomerFilteredList(fileredList)
                        }
                        else{
                          setCustomerFilteredList(customerList)
                        }
                      }}
                      isClearable
                      value={selectedCustomer}
                      options={customerList}
                      classNamePrefix="select2-selection"
                      isLoading={false}
                      id="productcustomer"
                    />
                  </div>

                  <SimpleBar style={{ maxHeight: "750px" , paddingBottom:"30px"}} autoHide={false}>
                  {customerFilteredList.map((entry, i) => (
                    <React.Fragment key={"outer"+i}>
                      {selectedCustId == entry.value ? <div ref={messagesEndRef} key={"sel-"+i} />: null}
                      <div className={selectedCustId == entry.value ? "border-bottom pointer-cursor-with-hover px-2 bg-light-blue" : "border-bottom pointer-cursor-with-hover px-2 "} key={i} onClick={()=>{
                        //getSalesEntryDetails(entry)
                        setSelectedCustId(entry.value)
                        getAllDetails(entry.value)
                      }}>
                        <CardBody className="no-gutters">
                          <div className="d-flex align-items-center">
                            <div className="pe-1 border-end">
                              <i className="mdi mdi-account-circle text-primary h1"></i>
                            </div>

                            <div className="ps-2">
                              <h5>{entry.name ? entry.name : "-"}</h5>
                              {entry.address && <p className="text-muted mb-1"><i className="bx bx-id-card"/> {entry.address}</p>}
                              {entry.email && <p className="text-muted mb-1"><i className="bx bx-envelope"/> {entry.email}</p>}
                              {entry.mobile && <p className="text-muted mb-0"> <i className="bx bx-mobile"/> {entry.mobile}</p>}
                            </div>
                          </div>
                        </CardBody>
                      </div>
                    </React.Fragment>
                  ))}
                    
                  </SimpleBar>
                  {(!searchInProgress && customerFilteredList.length == 0) && 
                    <Card color="warning" >
                      <CardBody>
                        <CardText className="font-size-16">
                          <i className="bx bx-sad me-1" /> Sorry, nothing found !!!
                        </CardText>
                      </CardBody>
                    </Card>
                  }
                </Col>
                <Col lg="8">
                {showLoading ? 
                <div className=" text-center">
                  <Spinner style={{ width: '3.2rem', height: '3.2rem' }} className="ms-3" color="primary" /> 
                </div>
                : 
                <>
                  <Row className="mt-1">
                    <Col className="text-end">
                      <Button className="btn btn-sm ms-1 me-2" onClick={() => {
                          close()
                        }}
                        >
                        <i className="fas fa-window-close"></i>
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-1 py-2">
                    <Col className="d-lg-flex justify-content-between">
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Txns #
                              </p>
                              <h4 className="mb-0">{customerSalesSummary.txncount}</h4>
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i className="bx bx-copy-alt font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Total
                              </p>
                              <h4 className="mb-0">{Number(customerSalesSummary.totalamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4>
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-info">
                                <i className="bx bx-purchase-tag-alt font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Paid
                              </p>
                              <h4 className="mb-0">{Number(customerSalesSummary.paidamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4>
                              {Number(customerSalesSummary.writeoff) > 0 ? <div className="text-muted font-size-12">Write-Off : {Number(customerSalesSummary.writeoff).toLocaleString('en-IN',{minimumFractionDigits: 2})} </div>: null}
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-success">
                                <i className="bx bx-archive-in font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                      <Card className="mini-stats-wid me-1">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                Balance
                              </p>
                              <h4 className="mb-0">{Number(customerSalesSummary.balanceamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}</h4>
                            </Media>
                            <div className="ms-2 avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-warning">
                                <i className="bx bx-bullseye font-size-24"></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="invoiceno"
                      columns={SalesEntryListColumns()}
                      data={salesEntryList}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="invoiceno"
                          data={salesEntryList}
                          columns={SalesEntryListColumns()}
                          bootstrap4
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive min-height-200">
                                    <BootstrapTable
                                      keyField="invoiceno"
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      //defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-hover"
                                      }
                                      headerWrapperClasses={"table-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                      noDataIndication={<div className="text-center">- No transactions found -</div>}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </Row>
                </>
                }
                </Col>
              </Row>
              
            </CardBody>

          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CustomerListDetailed
